import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { ChangeTemplateForm } from 'src/routes/Settings/Changes/components/ChangeTemplateForm';

export const CreateChangeTemplate: React.FC = () => {
  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Changes', href: '/settings/changes' },
            { text: 'Create Template' },
          ],
        }}
        title="Create Change Template"
        helpText="Create a new change order template with labor rates, design rates, and unit pricing."
      />
      <ChangeTemplateForm />
    </>
  );
};
